const zh = {
  i18nView: {
    login: '登录',
    account: '账号'
  }
};

export default zh;